import users from './users'
import documentTypes from './document-types'
import placeholders from './placeholders'
import professionalRoles from './professional-roles'
import sessionTemplates from './session-templates'
import modelTranslations from './model-translations'
import workspaces from './workspaces'

const admin = {
    users: Object.assign(users, users),
    documentTypes: Object.assign(documentTypes, documentTypes),
    placeholders: Object.assign(placeholders, placeholders),
    professionalRoles: Object.assign(professionalRoles, professionalRoles),
    sessionTemplates: Object.assign(sessionTemplates, sessionTemplates),
    modelTranslations: Object.assign(modelTranslations, modelTranslations),
    workspaces: Object.assign(workspaces, workspaces),
}

export default admin